export function CompanyProfileSkeleton() {
  return (
    <div className="container mx-auto animate-pulse p-6">
      {/* Breadcrumb */}
      <div className="bg-muted mb-4 h-4 w-24 rounded" />

      {/* Header */}
      <div className="mb-6 flex items-start justify-between">
        <div className="space-y-2">
          <div className="bg-muted h-6 w-48 rounded" />
          <div className="bg-muted h-4 w-36 rounded" />
        </div>
        <div className="flex gap-2">
          <div className="bg-muted h-8 w-20 rounded" />
          <div className="bg-muted h-8 w-20 rounded" />
        </div>
      </div>

      {/* Info card */}
      <div className="bg-card mb-6 rounded-lg border p-6">
        <div className="grid gap-6 md:grid-cols-3">
          {Array.from({ length: 3 }).map((_, col) => (
            <div key={col} className="space-y-4">
              {Array.from({ length: 3 }).map((_, row) => (
                <div key={row} className="space-y-1.5">
                  <div className="bg-muted h-2.5 w-24 rounded" />
                  <div className="bg-muted h-4 w-32 rounded" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-4 flex gap-1 border-b pb-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-muted h-8 w-24 rounded" />
        ))}
      </div>

      {/* Tab content */}
      <div className="bg-card h-64 rounded-lg border" />
    </div>
  )
}
